<app-page-title [title]="'Service Term Agreement'"></app-page-title>
<div class="form-container">
    <form
        name="service-term-form"
        [formGroup]="userForm"
        (ngSubmit)="onSubmit()"
    >
        <div class="row reviewOrder form-group">
            <div class="col-md-12">
                <h4>Service Terms</h4>
                <div>
                    <p>Please read the following Paragon Testing Enterprises Terms for Testing Services and Study Materials and the Paragon Testing Enterprises General Terms of Service.</p>
                </div>
                <div class="terms-and-conditions">
                    <div [innerHtml]="serviceTermContent"></div>
                </div>

                <br />
                <a
                    href="{{regPoliciesUrl}}"
                    target="_blank"
                >View our transfer, cancellation, and retake policies.</a>

                <div class="consent-checkbox">
                    <input
                        type="checkbox"
                        [checked]="personalInfoAgreement"
                        formControlName="personalInfoAgreement"
                        name="personalInfoAgreement"
                    />
                    <span>I certify that I am the person whose name and personal information are in the registration form and that I personally provided all of the information. I also certify that all of the information included in the registration form is true and complete.</span>
                </div>

                <div class="consent-checkbox">
                    <input
                        type="checkbox"
                        [checked]="serviceTermAgreement"
                        formControlName="serviceTermAgreement"
                        name="serviceTermAgreement"
                    />
                    <span>I have read, understand and agree to the Paragon Testing Enterprises Service Terms for Testing Sessions and Instructional Materials and the Paragon Testing Enterprises General Terms of Service (both displayed in the scrollable window above).</span>
                </div>

                <div class="consent-checkbox">
                    <input
                        type="checkbox"
                        [checked]="privacyPolicyAgreement"
                        formControlName="privacyPolicyAgreement"
                        name="privacyPolicyAgreement"
                    />
                    <span>I have read and understand the Paragon Testing Enterprises Privacy Policy (displayed in the scrollable window above) and consent to the collection, use, disclosure, retention, and deletion of my personal information in accordance with the Paragon Testing Enterprises Privacy Policy and as otherwise permitted by applicable law.</span>
                </div>

                <div class="consent-checkbox fadeInDiv">
                    <input
                        type="checkbox"
                        [checked]="ageAgreement"
                        formControlName="ageAgreement"
                        name="ageAgreement"
                    />
                    <span>If I am under the age of majority in the jurisdiction in which I live, then in addition to my own agreements and consents (confirmed above) my parent or legal guardian: (1) has read, understands and agrees on my behalf to both the Paragon Testing Enterprises Service Terms for Testing Sessions and Instructional Materials and the Paragon Testing Enterprises General Terms of Service; and (2) consents on my behalf to the collection, use, disclosure, retention and deletion of my personal information in accordance with the Paragon Privacy Policy and as otherwise permitted by applicable law.</span>
                </div>

                <br />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    By continuing you are confirming that you’ve agree to our Service Terms.
                </div>
                <div class="form-group">
                    <button
                        name="confirmationYesBtn"
                        type="submit"
                        class="btn btn-primary"
                        [disabled]="userForm.invalid || !f.personalInfoAgreement.value || !f.serviceTermAgreement.value || !f.privacyPolicyAgreement.value || !f.ageAgreement.value"
                    >
                        Agree and Continue
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>
